import { AppData, Lightning } from "@lightningjs/sdk";
import { Base } from "@lightningjs/ui-components";
import { AppSetup } from "../../../app-setup";
import { Helper } from "../../../helper";

export default class EPGChannelIconUI extends Base {
    _channelIdx = 0;
    _imgSrc = '';
    _focusColor: number = 0xffffffff;

    static override _template() {
        return {
            w: 100,
            h: 100,
            Icon: {
                x: 0,
                y: 0,
                w: 100,
                h: 100,
                rect: true,
                color: 0x1EFFFFFF,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 10 },
                Logo: {
                    x: 5,
                    y: 5,
                    w: 90,
                    h: 90,
                    src: '',
                    shader: { type: Lightning.shaders.RoundedRectangle, radius: 10 }
                }
            },
            HitArea: {
                x: 0,
                y: 0,
                w: 100,
                h: 100,
                rect: true,
                color: 0x00000000,
                collision: true,
                zIndex: 99,
            }
        }
    }

    static get __componentName() { return 'EPGChannelIconUI'; }

    override _init() {
        const { appState } = AppData as AppSetup;
        this._focusColor = Helper.getHexaColor(
            appState?.getAppApiConfig()?.appLayoutConfig?.textfocuscolor
        ) || 0xffffffff;
    }

    override _enable() {
        if (this._imgSrc) {
            (this as any).tag('Icon.Logo').patch({
                texture: {
                    type: Lightning.textures.ImageTexture,
                    src: this._imgSrc,
                }
            });
        }
    }

    static get tags() { return ['Icon']; }

    set channelIdx(val: number) {
        this._channelIdx = val;
    }

    set imgSrc(url: string) {
        this._imgSrc = url;
    }

    setHighlight(focused: boolean) {
        (this as any).tag('Icon').patch({ color: focused ? this._focusColor : 0x1EFFFFFF });
    }

    _handleClick() {
        (this as any).fireAncestors('$channelIconClicked', this._channelIdx);
        return true;
    }

    _handleScroll(obj: any) {
        const direction = (obj?.wheelDeltaY > 0) ? 'up' : 'down';
        (this as any).fireAncestors('$channelListScrolled', direction);
        return true;
    }
}
